var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack, Checkbox, FormControlLabel } from '@mui/material';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../styles/css/react-draft.css';
var DisclaimerOptionsEditor = /** @class */ (function (_super) {
    __extends(DisclaimerOptionsEditor, _super);
    function DisclaimerOptionsEditor(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        var disclaimerEditorState = EditorState.createEmpty();
        var disclaimerText = (_b = (_a = props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.disclaimerText;
        if (typeof disclaimerText != 'undefined' && disclaimerText) {
            var contentDraftBlock = htmlToDraft(disclaimerText);
            if (contentDraftBlock) {
                var contentState = ContentState.createFromBlockArray(contentDraftBlock.contentBlocks);
                disclaimerEditorState = EditorState.createWithContent(contentState);
            }
        }
        _this.state = {
            enableDisclaimer: (_d = (_c = props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseType) === null || _d === void 0 ? void 0 : _d.enableDisclaimer,
            disclaimerEditorState: disclaimerEditorState
        };
        return _this;
    }
    Object.defineProperty(DisclaimerOptionsEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var disclaimerEditorState = this.state.disclaimerEditorState;
            var wrapperClassName = (caseType === null || caseType === void 0 ? void 0 : caseType.enableDisclaimer) ? 'text-editor-wrapper' : 'text-editor-wrapper-readonly';
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, className: "case-types-tab-panel" }, { children: [_jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(FormControlLabel, { label: "Enable Disclaimer", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.enableDisclaimer, onChange: function (e) { return _this.onEnableDisclaimer(e); } }, void 0) }, void 0) }), void 0), _jsx(Editor, { readOnly: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableDisclaimer), editorState: disclaimerEditorState, wrapperClassName: wrapperClassName, editorClassName: "text-editor", toolbar: {
                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'history', 'image', 'link'],
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: {
                                inDropdown: false,
                                showOpenOptionOnHover: true,
                                defaultTargetOption: '_blank',
                                options: ['link', 'unlink']
                            },
                            history: { inDropdown: true },
                            image: {
                                urlEnabled: true,
                                uploadEnabled: true,
                                alignmentEnabled: true,
                                uploadCallback: undefined,
                                previewImage: false,
                                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                alt: { present: false, mandatory: false },
                                defaultSize: {
                                    height: 'auto',
                                    width: 'auto',
                                },
                                tEnabled: true,
                            }
                        }, onEditorStateChange: function (state) { return _this.onEditorStateChange(state); } }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(DisclaimerOptionsEditor.prototype, "onEditorStateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (editorState) {
            var _a, _b;
            this.setState({
                disclaimerEditorState: editorState
            });
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var disclaimerHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                var updatedCaseType = __assign(__assign({}, caseType), { disclaimerText: disclaimerHtml });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(DisclaimerOptionsEditor.prototype, "onEnableDisclaimer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { enableDisclaimer: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    DisclaimerOptionsEditor = __decorate([
        inject('caseTypesStore'),
        observer
    ], DisclaimerOptionsEditor);
    return DisclaimerOptionsEditor;
}(React.Component));
export default DisclaimerOptionsEditor;
